import http from '../../http'

const getLookerStudioToken = () => http.get('integrations/looker/new-token')

export {
  getLookerStudioToken
}